import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { WBBox, WBButton, WBDialog, WBForm } from '@admiin-com/ds-web';
import { useForm, useFormContext } from 'react-hook-form';
import LineItemsCreateForm from './LineItemCreateForm';
import { DocumentAnalysisLineItemInput } from '@admiin-com/ds-graphql';

interface Props {
  open: boolean;
  onClose: () => void;
  onAdd: (lineItem: DocumentAnalysisLineItemInput) => void;
  isEdit: boolean;
}
export default function LineItemsCreateModal(props: Props) {
  const { t } = useTranslation();
  const { handleSubmit } = useFormContext<DocumentAnalysisLineItemInput>();
  const handleAdd = (data: DocumentAnalysisLineItemInput, e: any) => {
    props.onAdd({
      ...data,
    });
  };
  return (
    <WBDialog fullScreen onClose={props.onClose} open={props.open}>
      <WBForm
        onSubmit={(e) => {
          e.stopPropagation();
          handleSubmit(handleAdd)(e);
        }}
        mt={0}
      >
        <DialogTitle textAlign={'center'} variant="h5">
          {props.isEdit
            ? t('editItem', { ns: 'taskbox' })
            : t('newItem', { ns: 'taskbox' })}
        </DialogTitle>
        <DialogContent dividers>
          <LineItemsCreateForm />
        </DialogContent>
        <DialogActions>
          <WBBox width="100%">
            <WBButton type="submit" sx={{ mt: 1 }} fullWidth>
              {props.isEdit
                ? t('save', { ns: 'taskbox' })
                : t('addItem', { ns: 'taskbox' })}
            </WBButton>
            <WBButton
              variant="outlined"
              type="button"
              onClick={props.onClose}
              sx={{ mt: 1 }}
              fullWidth
            >
              {t('back', { ns: 'taskbox' })}
            </WBButton>
          </WBBox>
        </DialogActions>
      </WBForm>
    </WBDialog>
  );
}
